import {Drawer} from '@mui/material';
import {TailwindContents} from '@wandb/weave/components/Tailwind';
import React from 'react';

import {DRAWER_WIDTH} from './constants';
import {WorkspaceTemplateContent} from './WorkspaceTemplateContent';
import {useWorkspaceTemplateDrawerContext} from './WorkspaceTemplateDrawerContextProvider';

const TRANSITION_DURATION = 500;
const SLOT_PROP = {
  backdrop: {
    style: {
      backgroundColor: 'var(--wb-bg-backdrop)',
    },
  },
  paper: {
    style: {
      marginTop: 'var(--wb-drawer-top-padding)',
      height: 'calc(100% - var(--wb-drawer-top-padding))',
      width: DRAWER_WIDTH,
    },
  },
};

export const WorkspaceTemplateDrawer = () => {
  const {isWorkspaceTemplateDrawerOpen, closeWorkspaceTemplateDrawer} =
    useWorkspaceTemplateDrawerContext();

  return (
    <Drawer
      anchor="right"
      open={isWorkspaceTemplateDrawerOpen}
      onClose={closeWorkspaceTemplateDrawer}
      transitionDuration={TRANSITION_DURATION}
      slotProps={SLOT_PROP}>
      <TailwindContents>
        <WorkspaceTemplateContent />
      </TailwindContents>
    </Drawer>
  );
};
